import script from "./PaginationHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationHandler.vue?vue&type=script&setup=true&lang=js"

import "./PaginationHandler.vue?vue&type=style&index=0&id=5000ff8a&lang=css"

const __exports__ = script;

export default __exports__